import * as yup from 'yup'

/** Схема формы ввода email с согласием на обработку данных. */
export const emailFormSchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Некорректный email')
    .required('Укажите email'),
  agreed: yup
    .boolean()
    .oneOf([true], 'Необходимо согласие')
    .required()
})

/** Схема формы ввода email для модалки привязки (без согласия). */
export const emailOnlySchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Некорректный email')
    .required('Укажите email')
})

export type EmailFormValues = yup.InferType<typeof emailFormSchema>
export type EmailOnlyValues = yup.InferType<typeof emailOnlySchema>
